'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$5(outer) {
  this.bF2 = null;
  this.bF0 = null;
  this.bF1 = false;
  this.bEY = null;
  this.bEZ = false;
  this.bF3 = false;
  this.bF4 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bF2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$5 as $c_Lpresto_TwoFactorAuthView$$anon$5 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$5;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$5() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$5 as $h_Lpresto_TwoFactorAuthView$$anon$5 };
$h_Lpresto_TwoFactorAuthView$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bF2;
});
$p.t = (function() {
  if ((!this.bF1)) {
    this.bF0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bF1 = true;
  }
  return this.bF0;
});
$p.ag = (function() {
  if ((!this.bEZ)) {
    this.bEY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vn(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().k3()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bEZ = true;
  }
  return this.bEY;
});
$p.v = (function() {
  if ((!this.bF4)) {
    this.bF3 = false;
    this.bF4 = true;
  }
  return this.bF3;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$5, "presto.TwoFactorAuthView$$anon$5", ({
  SV: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$5 as $d_Lpresto_TwoFactorAuthView$$anon$5 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$5.js.map
